module.exports = __webpack_public_path__ + "static/pic02-e305998c79ab5384cb60875f6f78e2b1.jpg";